import { useStaticQuery, graphql } from "gatsby";

export const useSiteMetadata = () => {
  const { contentfulComponent } = useStaticQuery(
    graphql`
      query MyExpertiseHeaderQuery {
        contentfulComponent(slug: { eq: "expertise-header" }) {
          headline
          decorator
          subhead
          asset {
            fluid {
              src
            }
          }
        }
      }
    `
  );
  return contentfulComponent;
};
